import React from 'react'

import {ZariContext} from '_zari/context'
import { Table, Button, Row, Col, Form, Divider } from '_zari/core'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

const ListaVentasSection = ({ idFacturacionRef, mostrarDetallesSection, idSocio, anioFacturacionRef }) => {
  const __zariContext = React.useContext(ZariContext)
  const [anioSeleccionado, setAnioSeleccionado] = React.useState(new Date().getFullYear())

  const [listaVentas, setListaVentas] = React.useState(null)

  const aniosOptions = React.useMemo(() => {
    const anioActual = new Date().getFullYear()
    const limiteAnios = anioActual - 10

    const output = []

    for (let i = anioActual; i >= limiteAnios; i--) {
      output.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return output
  }, [])

  const refrescarLista = React.useCallback(() => {
    setListaVentas(null)

    FacturacionHistorialService.obtenerHistorialxSocio({idSocio, anio: anioSeleccionado})
      .then(({data})=> {
        setListaVentas(data)
      })
      .catch(() => {
        setListaVentas(null)
        __zariContext.toast('danger', 'No se pudo obtener la lista de ventas.')
      })
  }, [__zariContext, idSocio, anioSeleccionado])

  const clickVerDetalles = React.useCallback(
    idFacturacion => {
      idFacturacionRef.current = idFacturacion
      anioFacturacionRef.current = anioSeleccionado
      mostrarDetallesSection(true)
    },
    [idFacturacionRef, anioFacturacionRef, mostrarDetallesSection, anioSeleccionado]
  )

  React.useEffect(() => {
    refrescarLista()
  }, [refrescarLista])

  return (
    <>
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label text='AÑO' htmlFor='select-anio' md={4} alignRightAt='md' />
            <Col md={8}>
              <Form.Select
                id='select-anio'
                name='select-anio'
                value={anioSeleccionado}
                onChange={e => setAnioSeleccionado(e.target.value)}
              >
                {aniosOptions}
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
      </Row>
      {
        listaVentas !== null && (
          <>
            <Divider />
            <Table
              filas={listaVentas}
              headRows={[
                { label: 'FECHA EMISION' },
                { label: 'TIPO-SERIE-NUMERO' },
                { label: 'IMPORTE TOTAL' },
                { label: 'MONEDA' },
                { label: '' }
              ]}
              maxRowsShown={10}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell>{`${row.tipoDocumento} - ${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
                  <Table.Cell>{row.monto || '--'}</Table.Cell>
                  <Table.Cell>{row.moneda || '--'}</Table.Cell>
                  <Table.Cell>
                    <Button tiny outline color='warning' onClick={() => clickVerDetalles(row._id)}>
                      Ver detalles
                    </Button>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </>
        )
      }
    </>
  )
}

export default React.memo(ListaVentasSection)
